import * as Sentry from '@sentry/browser';
import Debug from 'utils/debug';

interface DebugHandlerData {
    sentryFingerprint?: string[];
    [key: string]: unknown;
}

type DebugHandler = (error: unknown, data: DebugHandlerData) => void;

/**
 * Модуль регистрирует обработчик для отладочной утилиты,
 * служит для отсылки отладочной информации на сторонний сервис (на даннй момент - Sentry) <br>
 *
 * Имя обработчика - "out", Уровень логирования - PRODUCTION
 *
 * @example
 * Debug = require('utils/debug');
 * Debug.log('out', 'Ошибка!', {explain: 'Отладочное свойство'})
 * //Выводим и отсылаем полученный объект ошибки
 * Debug.log('out error', error, {explain: 'Тут получили ошибку.'})
 *
 * @param {Error|String} error  Объект ошибки или сообщение для отсылки.
 * @param {Object}       [data] Объект с вспомогательными свойствами.
 *
 * @type {Function}
 * @exports utils/debug/Outer
 */
const handler: DebugHandler = (error, data = {}) => {
    const { sentryFingerprint, ...extra } = data;
    Sentry.withScope((scope) => {
        scope.setTag('fromDebug', true);
        if (sentryFingerprint) {
            scope.setFingerprint(sentryFingerprint);
        }
        if (extra instanceof Object) {
            scope.setExtras(extra);
        }
        Sentry.captureException(error);
    });
};
Debug.registerLog('out', Debug.viewMods.PRODUCTION, handler);
